// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".my_pic{border-radius:5px;padding:3px;-webkit-box-sizing:border-box;box-sizing:border-box;border:2px dashed #ccc}.el-upload-list{display:none}.other_file{font-size:80px}.other_file .other_file_name{font-size:14px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.file_view_wrap{position:relative}.file_view_wrap .file_video_play{position:absolute;width:100%;height:100%;left:0;top:-5px;z-index:111;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;cursor:pointer}.file_view_wrap .file_video_play .el-icon-video-play{color:#fff;font-size:50px;opacity:1}.file_view_wrap .file_video_play:hover .el-icon-video-play{opacity:.6;font-size:50px}.upload-demo{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-bottom:10px}.upload-demo .el-upload,.upload-demo .el-upload .el-upload-dragger{width:100%}", ""]);
// Exports
exports.locals = {
	"g_main_sidebar_width": "60px",
	"g_sub_sidebar_width": "193px",
	"g_sidebar_width": "253px",
	"g_app_bg": "#fff",
	"g_main_bg": "#f5f7f9",
	"g_header_bg": "#222b45",
	"g_header_menu_color": "#fff",
	"g_header_menu_active_bg": "rgb(50.8349514563,64.2912621359,103.1650485437)",
	"g_main_sidebar_bg": "#2e3056",
	"g_main_sidebar_menu_color": "#fff",
	"g_main_sidebar_menu_active_bg": "hsla(0,0%,100%,.33)",
	"g_sub_sidebar_bg": "#fff",
	"g_sub_sidebar_menu_color": "#37414b",
	"g_sub_sidebar_menu_active_color": "#e7f4ff",
	"g_sub_sidebar_menu_active_bg": "#ecf2fa"
};
module.exports = exports;
